<template>
    <div class="isolate bg-slate-50 px-6 py-24 sm:py-32 lg:px-8 relative">
        <div class="mx-auto max-w-7xl">
            <div class="mx-auto max-w-2xl text-center">
                <span
                    class="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-600/10">Contact
                    us</span>
                <h2 class="mt-4 text-3xl font-semibold tracking-tight text-balance text-slate-900 sm:text-3xl">Have a
                    question or
                    want to work together?</h2>
                <p class="mt-2 text-lg/8 text-slate-600">
                    We'd love to hear from you. Just fill out the form below and
                    we'll get back to you as soon as possible.
                </p>
            </div>

            <div class="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-10 sm:mt-20 lg:grid-cols-5 lg:gap-16">
                <div class="lg:col-span-2">
                    <div class="rounded-2xl bg-slate-900 p-8 text-white shadow-sm h-full">
                        <h3 class="text-lg font-semibold">Get in touch</h3>
                        <p class="mt-2 text-sm text-slate-300">Reach us directly, or use the form and we'll respond
                            within one business day.</p>
                        <dl class="mt-8 space-y-6">
                            <div class="flex items-start gap-4">
                                <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-white/10 text-primary-300">
                                    <EnvelopeIcon class="size-5" aria-hidden="true" />
                                </div>
                                <div>
                                    <dt class="text-sm text-slate-400">Email</dt>
                                    <dd class="text-sm font-medium">hello@sultanavera.com</dd>
                                </div>
                            </div>
                            <div class="flex items-start gap-4">
                                <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-white/10 text-secondary-300">
                                    <PhoneIcon class="size-5" aria-hidden="true" />
                                </div>
                                <div>
                                    <dt class="text-sm text-slate-400">Phone</dt>
                                    <dd class="text-sm font-medium">+1 (555) 123-4567</dd>
                                </div>
                            </div>
                            <div class="flex items-start gap-4">
                                <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-white/10 text-accent-300">
                                    <MapPinIcon class="size-5" aria-hidden="true" />
                                </div>
                                <div>
                                    <dt class="text-sm text-slate-400">Location</dt>
                                    <dd class="text-sm font-medium">Online, worldwide</dd>
                                </div>
                            </div>
                        </dl>
                    </div>
                </div>

                <form action="#" method="POST" class="lg:col-span-3 rounded-2xl bg-white p-8 shadow-sm ring-1 ring-slate-900/5">
                    <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <div>
                    <label for="first-name" class="block text-sm/6 font-semibold text-slate-900">First name</label>
                    <div class="mt-2.5">
                        <input type="text" name="first-name" id="first-name" autocomplete="given-name"
                            class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-slate-900 outline-1 -outline-offset-1 outline-slate-300 placeholder:text-slate-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600" />
                    </div>
                </div>
                <div>
                    <label for="last-name" class="block text-sm/6 font-semibold text-slate-900">Last name</label>
                    <div class="mt-2.5">
                        <input type="text" name="last-name" id="last-name" autocomplete="family-name"
                            class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-slate-900 outline-1 -outline-offset-1 outline-slate-300 placeholder:text-slate-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <label for="email" class="block text-sm/6 font-semibold text-slate-900">Email</label>
                    <div class="mt-2.5">
                        <input type="email" name="email" id="email" autocomplete="email"
                            class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-slate-900 outline-1 -outline-offset-1 outline-slate-300 placeholder:text-slate-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <label for="phone-number" class="block text-sm/6 font-semibold text-slate-900">Phone number</label>
                    <div class="mt-2.5">
                        <div
                            class="flex rounded-md bg-white outline-1 -outline-offset-1 outline-slate-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary-600">
                            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                <select id="country" name="country" autocomplete="country" aria-label="Country"
                                    class="col-start-1 row-start-1 w-full appearance-none rounded-md py-2 pr-7 pl-3.5 text-base text-slate-500 placeholder:text-slate-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600 sm:text-sm/6">
                                    <option>US</option>
                                    <option>CA</option>
                                    <option>EU</option>
                                </select>
                                <ChevronDownIcon
                                    class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-slate-500 sm:size-4"
                                    aria-hidden="true" />
                            </div>
                            <input type="text" name="phone-number" id="phone-number"
                                class="block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-slate-900 placeholder:text-slate-400 focus:outline-none sm:text-sm/6"
                                placeholder="123-456-7890" />
                        </div>
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <label for="message" class="block text-sm/6 font-semibold text-slate-900">Message</label>
                    <div class="mt-2.5">
                        <textarea name="message" id="message" rows="4"
                            class="block w-full rounded-md bg-white px-3.5 py-2 text-base text-slate-900 outline-1 -outline-offset-1 outline-slate-300 placeholder:text-slate-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600" />
                    </div>
                </div>
                <SwitchGroup as="div" class="flex gap-x-4 sm:col-span-2">
                    <div class="flex h-6 items-center">
                        <Switch v-model="agreed"
                            :class="[agreed ? 'bg-primary-600' : 'bg-slate-200', 'flex w-8 flex-none cursor-pointer rounded-full p-px ring-1 ring-slate-900/5 transition-colors duration-200 ease-in-out ring-inset focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600']">
                            <span class="sr-only">Agree to policies</span>
                            <span aria-hidden="true"
                                :class="[agreed ? 'translate-x-3.5' : 'translate-x-0', 'size-4 transform rounded-full bg-white shadow-xs ring-1 ring-slate-900/5 transition duration-200 ease-in-out']" />
                        </Switch>
                    </div>
                    <SwitchLabel class="text-sm/6 text-slate-600">
                        By selecting this, you agree to our
                        {{ ' ' }}
                        <a href="#" class="font-semibold text-primary-600">privacy&nbsp;policy</a>.
                    </SwitchLabel>
                </SwitchGroup>
            </div>
            <div class="mt-10">
                <button type="submit"
                    class="block w-full rounded-md bg-primary-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Let's
                    talk</button>
            </div>

            <SocialMediaSection />
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/16/solid'
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/vue/24/outline'
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import SocialMediaSection from '@/components/sections/SocialMediaSection.vue'

const agreed = ref(false)
</script>